import React, { useState, useEffect } from 'react';
import {
  useSearchParams,
  useNavigate,
  createSearchParams,
} from 'react-router-dom';
import { Form, message, Modal } from 'antd';
import moment from 'moment';

import BannerView from './BannerView';
import { useMutation, useQuery } from '../../../hooks/useQuery';
import useStoreSite from '../../../hooks/useStoreSite';
import { GRID_LINK_CELL_STYLE } from '../../../config/contants';
import { getFileData } from '../../../config/utils/util';

// const sleep = ms => new Promise(r => setTimeout(r, ms));
/**
 * 배너관리 > 상세배너관리
 * @returns
 */
function Banner() {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  // const storeSiteId = useSelector(state => state.site.siteId, shallowEqual);
  const { siteId: storeSiteId } = useStoreSite();
  const SITE_ID = !storeSiteId
    ? process.env.REACT_APP_DEFAULT_SITE_ID
    : storeSiteId;

  // initial search values
  const initialSearchValues = {
    pageIndex: 1,
    pageSize: 10,
    recordCountPerPage: 10,
    siteId: SITE_ID,
  };

  /** query string */
  const [searchParams] = useSearchParams();
  const [search, setSearch] = useState(initialSearchValues);
  const [paging, setPaging] = useState();

  const [gridApi, setGridApi] = useState();
  const [columnDefs] = useState([
    {
      field: '',
      headerName: '',
      width: 50,
      headerCheckboxSelection: true,
      checkboxSelection: true,
    },
    {
      field: 'rnum',
      headerName: 'No',
      width: 60,
    },
    {
      field: 'bannerNm',
      headerName: '배너명',
      cellStyle: { ...GRID_LINK_CELL_STYLE },
      width: 150,
    },
    {
      field: 'bannerGroupNm',
      headerName: '배너그룹명',
      width: 150,
    },
    {
      field: 'linkUrl',
      headerName: '링크URL',
      width: 180,
    },
    {
      field: 'reflctAt',
      headerName: '반영여부',
      width: 100,
      valueGetter: params => {
        const { data } = params;
        return data.reflctAt === 'Y' ? '반영' : '미반영';
      },
    },
    {
      field: 'useAt',
      headerName: '사용여부',
      width: 100,
      valueGetter: params => {
        const { data } = params;
        return data.useAt === 'Y' ? '사용' : '미사용';
      },
    },
    { field: 'frstRegisterId', headerName: '등록자', width: 100 },
    {
      field: 'frstRegistPnttm',
      headerName: '등록일',
      width: 120,
      cellRenderer: params => {
        const { value } = params;
        return value ? moment(value).format('YYYY-MM-DD') : '';
      },
    },
  ]);

  const [visible, setVisible] = useState(false);

  // selectedRows
  const [selectedRows, setSelectedRows] = useState([]);

  // 수정여부
  const [isEdit, setIsEdit] = useState(false);

  // 상세정보
  const [detailData, setDetailData] = useState(null);

  // 배너그룹ID
  const [bannerGroupId, setBannerGroupId] = useState('');

  // 배너그룹
  const [bannerGroup, setBannerGroup] = useState([]);

  // 검색 Option
  const [searchOption] = useState({
    initialValues: {
      searchCondition: '1',
      searchKeyword: '',
    },
    items: [
      {
        type: 'select',
        name: 'searchCondition',
        placeholder: '선택하세요.',
        codes: [{ value: '1', text: '배너명' }],
      },
      {
        name: 'searchKeyword',
        placeholder: '검색어를 입력하세요.',
        type: 'input',
        codes: [],
      },
    ],
  });

  /**
   * API - 배너그룹 조회
   */
  const { dataBannerGroup } = useQuery(
    '/api/admin/banner/selectBannerGroups',
    { siteId: SITE_ID },
    {
      cacheTime: 0,
      enabled: !!SITE_ID,
      onSuccess: res => {
        if (res) {
          if (res.resultList && res.resultList.length > 0) {
            setBannerGroupId(res.resultList[0].bannerGroupId);
            setBannerGroup(res.resultList);
            setSearch(prevState => {
              return {
                ...prevState,
                bannerGroupId: res.resultList[0].bannerGroupId,
              };
            });
          }
        }
      },
    },
  );

  /**
   * API - 목록 조회
   */
  const {
    data,
    refetch: refetchList,
    // ...restQuery
  } = useQuery('/api/admin/banner/selectBannerList', search, {
    cacheTime: 0,
    enabled: !!search,
    onSuccess: res => {
      if (res) {
        setPaging(res.paginationInfo);
      }
    },
  });

  /**
   * API - 상세정보 조회
   */
  const {
    data: detail,
    refetch: refetchDetail,
    dataUpdatedAt,
    // ...restDetailQuery
  } = useQuery(
    '/api/admin/banner/selectBannerDetail',
    { bannerId: searchParams.get('bannerId'), siteId: SITE_ID },
    {
      cacheTime: 0,
      enabled: !!searchParams.get('bannerId'),
    },
  );

  /**
   * API - 정보등록
   * @param {*} pageIndex
   * @param {*} pageSize
   */
  const addMutation = useMutation('/api/admin/banner/insertBanner');

  /**
   * API - 정보삭제
   * @param {*} pageIndex
   * @param {*} pageSize
   */
  const deleteMutation = useMutation('/api/admin/banner/deleteBanner');

  /**
   * API - 정보수정
   * @param {*} pageIndex
   * @param {*} pageSize
   */
  const updateMutation = useMutation('/api/admin/banner/updateBanner');

  /**
   * API - 파일Upload
   * @TODO - 업로드 API 수정필요
   */
  const saveFilesMutation = useMutation(
    // '/api/admin/file/insertFiles',
    '/api/file/insertFiles',
    {},
    true,
  );

  /**
   * File Upload
   * @param {*} fileObj
   * @returns
   */
  const saveFiles = async files => {
    console.log('🚀 ~ saveFiles ~ files', files);
    let res;
    try {
      // const uploadFiles = files.map(file => {
      //   return { file: file.originFileObj };
      // });
      const uploadFiles = files.map(file => {
        return file;
      });
      console.log('🚀 ~ saveFiles ~ uploadFiles', uploadFiles);
      res = await saveFilesMutation.mutateAsync(uploadFiles);
    } catch (error) {
      console.error('saveFiles', error);
    }
    console.log('🚀 ~ saveFiles ~ res', res);
    return res;
  };

  /**
   * 페이징 처리
   * @param {*} pageIndex
   * @param {*} pageSize
   */
  const handlePagination = (pageIndex, pageSize) => {
    setSearch(preSearch => {
      return { ...preSearch, pageIndex, pageSize };
    });
  };

  /**
   * 검색 처리
   * @param {*} searchWord
   */
  const handleSearch = search => {
    setSearch(() => {
      return { ...initialSearchValues, ...search, bannerGroupId };
    });
  };

  /**
   * 행 클릭
   * @param {*} row
   * @param {*} column
   */
  const handleRowClick = params => {
    console.log('🚀 ~ handleRowClick ~ params', params);
  };

  /**
   * Cell 클릭
   * @param {*} bool
   */
  const handleCellClick = params => {
    // console.log('🚀 handleCellClick ~ params', params);
    const { data, colDef } = params;
    if (colDef?.field === 'bannerNm' && data?.bannerId) {
      // go Navigate
      navigate({
        pathname: '/cms/banner',
        search: `?${createSearchParams({
          bannerId: data.bannerId,
        })}`,
      });

      // refetchDetail
      if (searchParams.get('bannerId')) refetchDetail();

      // Open Drawer
      // if (!visible) handleDraw(true);
    }
  };

  /**
   * draw 핸들러
   * @param {*} bool
   */
  const handleDraw = bool => {
    setVisible(bool);
  };

  /**
   * Move List page
   */
  const handleMoveList = () => {
    // Move List
    navigate('/cms/banner');
  };

  /**
   * grid api 추가
   * @param {*} param0
   */
  const handleGridOption = ({ api }) => {
    api.sizeColumnsToFit();
    setGridApi(api);
  };

  /**
   * grid size changed
   * @param {*} param0
   */
  const handleGridSizeChanged = ({ api }) => {
    api.sizeColumnsToFit();
  };

  /**
   * Row Selection Checked
   * @param {*} bool
   */
  const handleSelectionChanged = ({ api }) => {
    const _selectedRows = api.getSelectedRows();
    // console.log('🚀 ~ handleSelectionChanged ~ selectedRows', selectedRows);
    // Set SelectedRows
    setSelectedRows(_selectedRows);
  };

  /**
   * Form Finish
   * @param {*} values
   */
  const handleFinish = async values => {
    console.log('🚀 ~ handleFinish values', values);
    // console.log(
    //   '🚀 ~ file: Faq.js ~ line 262 ~ Faq ~ atchFile[0]',
    //   typeof values.atchFile[0].originFileObj,
    //   values.atchFile[0].originFileObj instanceof File,
    // );

    let bannerImage = '';
    let bannerImageFile = '';
    const { atchFile, atchFileId } = values;
    console.log(
      '🚀 ~ handleFinish ~ atchFile, atchFileId',
      atchFile,
      atchFileId,
    );
    // File Upload
    if (atchFile && Array.isArray(atchFile) && atchFile[0].originFileObj) {
      try {
        const res = await saveFiles(atchFile);
        console.log('🚀 ~ handleFinish ~ res', res);
        bannerImage = atchFile[0].name;
        bannerImageFile = res.result.fileIds && res.result.fileIds[0];
      } catch (err) {
        console.error('saveFiles err', err.message);
        bannerImage = '';
        bannerImageFile = '';
      }
    }

    const dataValues = {
      ...values,
      atchFile: true,
      bannerImage,
      bannerImageFile,
      reflctAt: values.reflctAt ? 'Y' : 'N',
      useAt: values.useAt ? 'Y' : 'N',
      userId: 'admin', // 필수항목 @TODO - 세션적용확인
      siteId: SITE_ID,
    };

    /* eslint no-unreachable: "off" */
    // return;

    if (isEdit) {
      const sendValues = {
        ...dataValues,
        lastUpdusrId: 'admin', // 필수항목 @TODO - 세션적용확인
      };
      // API Call - 정보수정
      updateMutation.mutate(sendValues, {
        onSuccess: res => {
          if (res?.status === 200) {
            // Message
            Modal.success({
              content: '수정 하였습니다.',
              onOk: () => {
                // Refetch - siteList
                refetchList();
              },
            });
          } else {
            const { status, statusText } = res;
            message.error(`[${status} - ${statusText}]`);
          }
        },
        onError: async error => {
          console.error('🚀 ~ updateMutation : error2', JSON.stringify(error));
        },
        onSettled: async () => {
          // console.log('🚀 ~ updateMutation onSettled!!!');
          // Form Reset
          handleReset();
          // Close Drawer
          handleDraw(false);
          // Move List page
          handleMoveList();
        },
      });
    } else {
      const sendValues = {
        ...dataValues,
        frstRegisterId: 'admin', // 필수항목 @TODO - 세션적용확인
      };
      // API Call - 정보등록
      addMutation.mutate(sendValues, {
        onSuccess: res => {
          // console.log('🚀 ~ addMutation ~ onSuccess: ~ res', res);
          if (res?.status === 200) {
            // Message
            Modal.success({
              content: '등록 하였습니다.',
              onOk: () => {
                // Refetch - siteList
                refetchList();
              },
            });
          } else {
            const { status, statusText } = res;
            message.error(`[${status} - ${statusText}]`);
          }
        },
        onError: async error => {
          console.error('🚀 ~ addMutation : error2', JSON.stringify(error));
          // message.error(error.message);
        },
        onSettled: async () => {
          // console.log('🚀 ~ addMutation onSettled!!!');
          // Form Reset
          handleReset();
          // Close Drawer
          handleDraw(false);
          // Move List page
          handleMoveList();
        },
      });
    }
  };

  /**
   * 정보삭제 처리
   */
  const handleDelete = () => {
    if (selectedRows && Array.isArray(selectedRows)) {
      if (selectedRows.length < 1) {
        Modal.warning({
          content: '삭제할 대상을 선택해주세요.',
        });
        return;
      }
      const bannerIds = selectedRows.map(item => {
        return {
          bannerId: item.bannerId,
        };
      });
      const sendDataValues = {
        items: bannerIds,
      };

      // API Call - 정보 삭제하기
      deleteMutation.mutate(sendDataValues, {
        onSuccess: res => {
          if (res?.status === 200) {
            // Message
            Modal.success({
              content: '삭제 하였습니다.',
              onOk: () => {
                // Refetch - siteList
                refetchList();
              },
            });
          } else {
            const { status, statusText } = res;
            message.error(`[${status} - ${statusText}]`);
          }
        },
        onError: async error => {
          console.error('🚀 ~ deleteMutation : error2', JSON.stringify(error));
          // message.error(error.message);
        },
        onSettled: async () => {
          // deselect
          if (gridApi) gridApi.deselectAll();
        },
      });
    }
  };

  /**
   * 배너그룹ID Set
   * @param {*} value
   */
  const handleBannerGroupId = value => {
    setBannerGroupId(value);
  };

  /**
   * Form Reset
   */
  const handleReset = (_isEdit = false) => {
    console.log('🚀 ~ handleReset ~ _isEdit, detailData', _isEdit, detailData);
    // 수정시
    if (_isEdit) {
      form.setFieldsValue({ ...detailData });
    } else {
      form.resetFields();
      // 수정여부 - 등록처리
      setIsEdit(false);
    }
  };

  /** ***************************************************************
   *  useEffect
   *************************************************************** */
  useEffect(() => {
    if (detail?.result) {
      const formData = {
        ...detail.result,
        atchFile: getFileData(detail.result.bannerImage),
        reflctAt: detail.result.reflctAt === 'Y',
        useAt: detail.result.useAt === 'Y',
      };
      // Set form Fileds value
      form.setFieldsValue({
        ...formData,
      });

      // Open Drawer
      if (!visible) handleDraw(true);
      // 상세정보 세팅
      setDetailData({ ...formData });
      // 수정여부-수정
      setIsEdit(true);
    }
  }, [detail, dataUpdatedAt, form]);

  /**
   * props 세팅
   */
  const props = {
    form,
    paging,
    list: data?.resultList,
    columnDefs,
    gridOptions: {
      rowSelection: 'multiple', // single, multiple
      enableRangeSelection: true,
      suppressRowClickSelection: true,
      headerHeight: 40,
      // rowHeight: 40,
    },
    visible,
    // detail,
    selectedRows,
    isEdit,
    searchOption,
    bannerGroupId,
    bannerGroup,
    onBannerGroupId: handleBannerGroupId,
    onPaging: handlePagination,
    onRowClick: handleRowClick,
    onCellClick: handleCellClick,
    onDraw: handleDraw,
    onGridReady: handleGridOption,
    onSelectionChanged: handleSelectionChanged,
    onFinish: handleFinish,
    onReset: handleReset,
    onSearch: handleSearch,
    onDelete: handleDelete,
    onMoveList: handleMoveList,
    onGridSizeChanged: handleGridSizeChanged,
  };

  return <BannerView {...props} />;
}

export default Banner;
